export default __webpack_public_path__ + "static/media/9.d24d3f15.png";